import { render, staticRenderFns } from "./MultipleChoiceDropdownResponse.vue?vue&type=template&id=7096ab6c&"
import script from "./MultipleChoiceDropdownResponse.vue?vue&type=script&lang=ts&"
export * from "./MultipleChoiceDropdownResponse.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports